import React from 'react';
import { NO_IMG_URL } from 'Utils/constants';
import styles from './imagegallery.module.less';

export default class ImageGallery extends React.Component {
  constructor(props) {
    super(props);
    let current = props.images.length > 0 ? props.images[0] : { path: NO_IMG_URL };
    this.state = {
      current: current,
      idx: 0
    };
  }

  changeImage = (img, idx) => this.setState({ current: img, idx: idx });

  render() {
    return (
      <div className={styles.imageGallery}>
        <div className={styles.activeImage}>
          <img src={this.state.current.path} alt={this.state.current.alt} />
        </div>
        <div className={styles.thumbnails}>
          {this.props.images.map((img, idx) => (
            <img
              src={img.path}
              alt={img.alt}
              key={idx}
              onClick={() => this.changeImage(img, idx)}
              className={idx === this.state.idx ? styles.active : ''}
            />
          ))}
        </div>
      </div>
    );
  }
}
